"use strict";
exports.__esModule = true;
exports.c_table_m_compact_cell_PaddingTop = {
  "name": "--pf-v5-c-table--m-compact--cell--PaddingTop",
  "value": "0.5rem",
  "var": "var(--pf-v5-c-table--m-compact--cell--PaddingTop)"
};
exports["default"] = exports.c_table_m_compact_cell_PaddingTop;